import * as rmd from 'material-ui';
import React from 'react';

class Checkboxes extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = { value: this.parseValue(props.value), options: props.options };
    }

    parseValue = value => {
        if (!value && value !== 0) return [];
        try {
            // if array passed
            // if (typeof value == 'string') throw new Error();
            if (this.props.output == 'csv') {
                value = value + '';
                value = _.compact((value || '').split(','));
            } else {
                value = JSON.parse(value);
            }
        } catch (e) {
            console.log('Checkboxes could not parse values', value);
            if (this.props.output == 'csv') {
                value = _.compact((value || '').split(','));
            }
        }

        return value || [];
    };

    componentWillReceiveProps = nextProps => {
        this.setState({ value: this.parseValue(nextProps.value) });
    };

    onCheck = (key, isChecked) => {
        this.setState({
            value: isChecked ? [...this.state.value, String(key)] : this.state.value.filter(v => v !== String(key))
        }, () => {
            return this.props.output === 'csv' ? this.props.onChange(this.props.propKey, this.state.value.join(",")) : this.props.onChange(this.props.propKey, this.state.value);
        });
    };

    render() {
        const { value } = this.state;

        return (
            <div>
                <h4>{this.props.label}</h4>
                {this.state.options.map(o => {
                    return (
                        <rmd.Checkbox
                            checked={value && !!value.find(v => v == o.key)}
                            label={o.label}
                            key={o.key}
                            onCheck={(e, isChecked) => this.onCheck(o.key, isChecked)}
                        />
                    );
                })}
            </div>
        );
    }
}

export default Checkboxes;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/Checkboxes.js
 **/